import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import SwipeToRedeem from '../../../components/SwipeToRedeem/SwipeToRedeem';
import PageSlug from '../../../components/PageSlug';
import routeNames from '../../../constants/routeNames';
import './VoucherPage.css';
import Brand from '../../../components/Brand';
import Footer from '../../../components/Footer';
import { useContent, useLoading, useLocationContext } from '../../../hooks/customHooks';
import SocialShares from '../../../components/SocialShares/SocialShares';
import WhatsappButton from '../../../components/WhatsappButton';
import { Link } from 'react-router-dom';
import Api from '../../../api';
import { CampaignTypes } from '../../../constants/CampaignTypes';
import LoyaltySteps from '../../../components/Loyalty/LoyaltySteps';

export default function VoucherPage() {
    const location = useLocation();
    const { content } = useContent();
    const { loading, setLoading } = useLoading();
    const [isUploading, setIsUploading] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const s = content?.pages?.swipe_to_redeem?.settings;
    const cServesMultiple = content?.servesMultiple;
    const c = content?.pages?.swipe_to_redeem?.content;
    const g = content?.global_settings?.images;
    const sw = content?.global_settings?.swipe;
    const showSocials = s?.footer_social;
    const whatsapp = s?.whatsapp;
    const { journey, loyalty } = content || {};
    const navigate = useNavigate();

    const { selectedLocation, updateLocationContext } = useLocationContext();
    useEffect(() => {
        const { voucher, instantWin } = journey || {};
        window.scrollTo({ top: 0 });
        setLoading(true);
        (async () => {
            if (!selectedLocation) {
                let selectedVenue = await Api.getSelectedVenue(location.state?.unique);
                updateLocationContext({
                    selectedLocation: selectedVenue?.data,
                    nearbyLocations: [selectedVenue?.data],
                });
            }
        })();

        if (!location.state) {
            navigate(routeNames.HOME);
            return;
        }
        if (!location.state?.firstTime) {
            if (!voucher && !instantWin) {
                if (content?.type === CampaignTypes.GAME_AT_THE_END) {
                    navigate(`/game/location-check/${location?.state?.unique}`);
                } else {
                    navigate(routeNames.REDEEM_SUCCESS, {
                        state: { serve: '', unique: location?.state?.unique, callbackUrl: location?.state?.callbackUrl },
                    });
                }
            } else if (voucher) {
                navigate(routeNames.VOUCHER, {
                    state: {
                        data: location.state?.uniqueData,
                        unique: location.state?.unique,
                        type: location.state?.type,
                        venueId: location.state?.venueId,
                        serve: location?.state?.serve,
                        callbackUrl: location?.state?.callbackUrl,
                    },
                });
            } else if (!voucher && instantWin) {
                if (content?.type === CampaignTypes.GAME_AT_THE_END) {
                    navigate(`/game/location-check/${location?.state?.unique}`);
                } else {
                    navigate(`/instant-win/check/${location?.state?.unique}`);
                }
            }
        }
        setLoading(false);
        // eslint-disable-next-line
    }, []);

    const onCreateUpload = e => {
        setIsUploading(true);
        const file = e.target.files[0];
        setFileName(file?.name);
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            const fileObject = {
                name: file.name,
                mimeType: file.type,
                fileContent: reader.result.split(',')[1],
            };
            Api.uploadImage(fileObject)
                .then(res => {
                    if (res && res?.result && res?.data) {
                        setUploadedFile(res?.data?.url);
                    }
                })
                .finally(() => {
                    setIsUploading(false);
                });
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };

    if (!location.state) {
        return <Navigate to={routeNames.HOME} replace />;
    }

    return (
        <div className={`page-wrapper ${s?.bg && g?.bg ? 'has-bg' : ''}`}>
            {s?.bg && g?.bg && (
                <div
                    className={`${s?.bg && g?.bg ? 'with-bg' : ''}`}
                    style={{ backgroundImage: s?.bg && g?.bg && `url(${g?.bg})` }}
                ></div>
            )}
            {s?.header && g?.header && <Brand image={g?.header} />}
            <main>
                {s?.logo && g?.logo && (
                    <section className="campaign-logo">
                        <Link to={routeNames.HOME} className="brand-logo">
                            <img className="header-title-image" alt="" src={g?.logo} />
                        </Link>
                    </section>
                )}

                <section
                    className={`main-content ${s?.bg && g?.bg ? 'transparent-container' : ''}`}
                >
                    <div className="margin-small">
                        <PageSlug className="mt-0">
                            <h1
                                className="brand-color mt-0"
                                dangerouslySetInnerHTML={{ __html: c?.title?.value }}
                            ></h1>
                            <p>
                                {' '}
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: cServesMultiple
                                            ? c?.multiple_serve_description?.value
                                            : c?.description?.value,
                                    }}
                                ></span>{' '}
                                {cServesMultiple && location?.state?.serve}
                            </p>
                            {/* Can only set one to dangerouslySetInnerHTML */}
                        </PageSlug>
                        <p dangerouslySetInnerHTML={{ __html: c?.availability?.value }}></p>
                    </div>
                    {selectedLocation && (
                        <section className="section-lite text-center card location-result mx-0">
                            <h3>{selectedLocation.name}</h3>
                            <p>{selectedLocation.formattedAddress}</p>
                        </section>
                    )}
                    <p
                        style={{ marginBottom: '30px' }}
                        dangerouslySetInnerHTML={{ __html: c?.swipe_instructions?.value }}
                    ></p>
                    {location.state && (
                        <>
                            {sw?.file_upload_required ? (
                                <>
                                    {!uploadedFile && (
                                        <label className="btn btn-brand btn-block">
                                            {isUploading ? 'Please wait...' : 'Upload image'}
                                            {!isUploading && (
                                                <>
                                                    <svg
                                                        width="29"
                                                        style={{
                                                            marginLeft: '10px',
                                                        }}
                                                        height="20"
                                                        viewBox="0 0 29 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M13.25 20H7.625C5.72917 20 4.10917 19.3437 2.765 18.0312C1.42083 16.7187 0.749167 15.1146 0.750001 13.2187C0.750001 11.5937 1.23958 10.1458 2.21875 8.875C3.19792 7.60417 4.47917 6.79167 6.0625 6.4375C6.58333 4.52083 7.625 2.96875 9.1875 1.78125C10.75 0.59375 12.5208 0 14.5 0C16.9375 0 19.0054 0.849167 20.7037 2.5475C22.4021 4.24583 23.2508 6.31333 23.25 8.75C24.6875 8.91667 25.8804 9.53667 26.8288 10.61C27.7771 11.6833 28.2508 12.9383 28.25 14.375C28.25 15.9375 27.7029 17.2658 26.6087 18.36C25.5146 19.4542 24.1867 20.0008 22.625 20H15.75V11.0625L17.75 13L19.5 11.25L14.5 6.25L9.5 11.25L11.25 13L13.25 11.0625V20Z"
                                                            fill="var(--secondary_text)"
                                                        />
                                                    </svg>
                                                </>
                                            )}
                                            <input
                                                onChange={onCreateUpload}
                                                type="file"
                                                name="image"
                                                accept="image/*"
                                                hidden
                                                disabled={isUploading}
                                            />
                                        </label>
                                    )}
                                    {uploadedFile && (
                                        <>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto',
                                                    position: 'relative',
                                                    marginBottom: '24px',
                                                    border: '1px solid var(--primary_text)',
                                                    width: '100%',
                                                    maxWidth: '329px',
                                                    padding: '0px 20px 0px 0px',
                                                    borderRadius: '4px',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <img
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        objectFit: 'cover',
                                                        float: 'left',
                                                    }}
                                                    alt="Uploaded "
                                                    src={uploadedFile}
                                                />
                                                <label
                                                    style={{
                                                        float: 'left',
                                                        marginLeft: '16px',
                                                        textAlign: 'left',
                                                        maxWidth: '210px',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis',
                                                    }}
                                                >
                                                    {fileName}
                                                </label>
                                                <div
                                                    style={{
                                                        float: 'right',
                                                        marginLeft: 'auto',
                                                        paddingTop: '2px',
                                                    }}
                                                    onClick={() => {
                                                        setUploadedFile(null);
                                                    }}
                                                >
                                                    <svg
                                                        width="15"
                                                        height="15"
                                                        viewBox="0 0 15 15"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <rect
                                                            y="1.47656"
                                                            width="2"
                                                            height="18.479"
                                                            rx="1"
                                                            transform="rotate(-45 0 1.47656)"
                                                            fill="var(--primary_text)"
                                                        />
                                                        <rect
                                                            x="13.0703"
                                                            y="0.546875"
                                                            width="2"
                                                            height="18.479"
                                                            rx="1"
                                                            transform="rotate(45 13.0703 0.546875)"
                                                            fill="var(--primary_text)"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>
                                            <SwipeToRedeem
                                                unique={location.state.unique}
                                                type={location.state.type}
                                                venueId={location.state.venueId}
                                                title={c?.swipe_title?.value}
                                                serve={location?.state?.serve}
                                                uploadedFile={uploadedFile}
                                                token={location?.state?.token}
                                                callbackUrl={location?.state?.callbackUrl}
                                            />
                                        </>
                                    )}
                                </>
                            ) : (
                                <SwipeToRedeem
                                    unique={location.state.unique}
                                    type={location.state.type}
                                    venueId={location.state.venueId}
                                    title={c?.swipe_title?.value}
                                    serve={location?.state?.serve}
                                    token={location?.state?.token}
                                    callbackUrl={location?.state?.callbackUrl}
                                />
                            )}
                        </>
                    )}
                </section>
                <section
                    className={
                        'transparent-container ' + (!showSocials && !whatsapp ? 'hidden' : '')
                    }
                >
                    {showSocials && <SocialShares></SocialShares>}
                    {whatsapp && <WhatsappButton />}
                </section>

                {s?.footer && (
                    <Footer className={`${s?.bg && g?.bg ? 'transparent-container' : ''}`} />
                )}
            </main>
        </div>
    );
}
